import DuckHeaderAction from "duck/ui/components/DuckHeaderAction";

import IngestionInfo from "features/ui/Ingestion/IngestionInfo";

import UserMenu from "./UserMenu";

interface Props {
  routeActions?: JSX.Element[];
}

const DEFAULT_RIGHT_SIDE_ITEMS = [
  <IngestionInfo />,
  <DuckHeaderAction />,
  <UserMenu />,
];

const CommonHeaderActions = ({ routeActions = [] }: Props) => (
  <div className="flex flex-row gap-2 items-center flex-1 justify-end min-w-0">
    {[...routeActions, ...DEFAULT_RIGHT_SIDE_ITEMS].map((item, i) => (
      <div key={i}>{item}</div>
    ))}
  </div>
);

export default CommonHeaderActions;
